// import { jsPDF } from "jspdf";
// import {font} from '../../public/assets/font/Sarabun-Regular-normal';

// const editor_PDF = {
//     data() {
//         return {
//             th: this.$thaidate,
//         }
//     },
//     methods: {
//         printPDF(PDF){
//             const dateObj = new Date();
//             let time = `${dateObj.getDate()}-${dateObj.getMonth()+1}-${dateObj.getFullYear()+543}`

//             const text_datePDF = `ข้อมูล ณ วันที่ ${this.changeDateToThai(dateObj)}`
//             const datePDF_pos = [PDF.setPosition[0],PDF.setPosition[1]]

//               const doc = new jsPDF(PDF.streak, 'pt');
//               doc.addFileToVFS("m.ttf", font);
//                   doc.addFont("m.ttf","m","normal");
//                   doc.setFont("m");  
              
//               doc.autoTable({
                
//                 startY: PDF.startMargin,
//                 margin: PDF.marginPDF,
//                 styles: {

//                           font:'m',          
//                         },
                        
//                         headStyles:{
//                             fontSize: 10,
//                             fontStyle: 'bolder',
//                             minCellWidth: PDF.minCell,
//                             halign: 'center',
//                             valign: 'middle',
//                             fillColor: PDF.fillColorPDF,
                          
//                           },
//                           bodyStyles:{
//                             fontSize: PDF.Body_FontSize,
//                           },
                                
//                 columns: PDF.columns,
//                 body : PDF.data,
//                 theme: PDF.PDF_Styles,

//                 //  didDrawCell: function (data) {
               
//                 //   if (data.section === 'head') {
                  
                    
//                 //     const cellHeight = data.cell.height;
//                 //     const cellWidth = data.cell.width;
//                 //     const cellX = data.cell.x;
//                 //     const cellY = data.cell.y;
              
//                 //     doc.text(data.cell.text, cellX + cellWidth / 2, cellY + cellHeight / 2, {
//                 //       align: 'center',
//                 //       valign: 'middle',
//                 //       angle: 90,
//                 //       textColor: PDF.fillColorPDF
//                 //     });
              
                    
//                 //     data.cell.text = '';
//                 //   }
//                 // },

//                   didParseCell:  (HookData) =>{
//                     if (HookData.cell.text[0]== '' || HookData.cell.text[0]== null ||  
//                     HookData.cell.text[0]== 'null' || HookData.cell.text[0]== undefined
//                     || HookData.cell.text[0]== ' -' ) {
                      
//                         HookData.cell.text = '-';
//                     }     
//                     if (HookData.cell.text[0]== '-' ) {
//                       // console.log(HookData)
//                       HookData.cell.styles.halign = 'center';
//                       HookData.cell.styles.valign = 'middle';
//                   }
                  
//                   if (PDF.checkBody_Center) {
//                     console.log(PDF.checkBody_Center)
//                     const column = HookData.column.dataKey
//                     PDF.Body_Center.filter((item)=>{
//                         if (column === item) {
//                             HookData.cell.styles.halign = 'center';
//                             // HookData.cell.styles.valign = 'middle';
//                         }
//                     })
//                   }

//                   if (PDF.check_fill_row !== undefined && PDF.check_fill_row !== false) {
//                     const column = HookData.column.dataKey
//                     const row = HookData.cell.text
                    
//                     for (let index = 0; index < PDF.fill_row_detail.length; index++) {
//                       const element = PDF.fill_row_detail[index];
//                       if (column == element.name_row) {
//                         for (let index2 = 0; index2 < element.detail_row.length; index2++) {
//                          const element_fill = element.detail_row[index2];
//                           if (element_fill.check_text == row) {
//                             HookData.cell.styles.fillColor = element_fill.fill_color
//                           }
//                         }
//                       }
//                     }
                    
//                   }

//                   },
//                   didDrawCell: function () {
//                     doc.setFontSize(13);
//                     doc.text(text_datePDF, datePDF_pos[0], datePDF_pos[1], null, null, "right");

//                   },
//               });

//               const pageCount = doc.internal.getNumberOfPages()
//               const PageTo_pos = [PDF.setPosition[2],PDF.setPosition[3]]
//               for (let index = 0; index < pageCount; index++) {
//                 doc.setPage(index)
//                 doc.setFontSize(13);
//                 let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber
//                 const text_PageTo = `หน้า ${pageCurrent} จาก ${pageCount}`
//                 doc.text(text_PageTo,PageTo_pos[0],PageTo_pos[1], null, null, "right")
                
//                 if (PDF.textHeader_allPages) {
//                   const pageWidth = doc.internal.pageSize.getWidth();
//                   doc.setFontSize(18);
//                   const textWidth = doc.getStringUnitWidth(PDF.setTextHeader_allPages) * doc.internal.getFontSize();
//                   const x = (pageWidth - textWidth) / 2;
//                   doc.text(PDF.setTextHeader_allPages, x, 60);
//                 } 
//               }

//               const setPaper = PDF.streak === 'l' ? '(แนวนอน)' : '(แนวตั้ง)'
//               doc.save(`${PDF.FileName} ${setPaper} ${time}.pdf`);
//         },
//     },
// }

// export default editor_PDF

import { jsPDF } from "jspdf";
import {font} from '../../public/assets/font/Sarabun-Regular-normal';

const editor_PDF = {
    data() {
        return {
            th: this.$thaidate,
        }
    },
    methods: {
        printPDF(PDF){
          // console.log(PDF)
            const dateObj = new Date();
            let time = `${dateObj.getDate()}-${dateObj.getMonth()+1}-${dateObj.getFullYear()+543}`

            const text_datePDF = `ข้อมูล ณ วันที่ ${this.changeDateToThai(dateObj)}`
            const datePDF_pos = [PDF.setPosition[0],PDF.setPosition[1]]
            PDF.data.forEach((item, index) => {
              item.index = index + 1;
            });

              const doc = new jsPDF(PDF.streak, 'pt');
              doc.addFileToVFS("m.ttf", font);
                  doc.addFont("m.ttf","m","normal");
                  doc.setFont("m");  
              
              doc.autoTable({
                startY: PDF.startMargin,
                margin: PDF.marginPDF,
                styles: {

                          font:'m',
                                              
                        },
                        headStyles:{
                            fontSize: PDF.Col_FontSize,
                            fontStyle: 'bolder',
                            minCellWidth: PDF.minCell,
                            halign: 'center',
                            valign: 'middle',
                            fillColor:PDF.fillColorPDF,
                          },
                          bodyStyles:{
                            fontSize: PDF.Body_FontSize,
                            
                          },
                          columnStyles: PDF.columnsStyles,       
                columns: PDF.columns, 
                body : PDF.data,
                theme: PDF.PDF_Styles,

                  didParseCell:  (HookData) =>{
                    if (HookData.cell.text[0]== '' || HookData.cell.text[0]== null ||  
                    HookData.cell.text[0]== 'null' || HookData.cell.text[0]== undefined
                    || HookData.cell.text[0]== ' -' ) {
                      
                        HookData.cell.text = '-';
                    }     
                    if (HookData.cell.text[0]== '-' ) {
                      // console.log(HookData)
                      HookData.cell.styles.halign = 'center';
                      HookData.cell.styles.valign = 'middle';
                  }

                  
                  if (PDF.checkBody_Center) {
                    const column = HookData.column.dataKey
                    PDF.Body_Center.filter((item)=>{
                        if (column === item) {
                            HookData.cell.styles.halign = 'center';
                        }
                    })
                  }

                  if (PDF.check_fill_row !== undefined && PDF.check_fill_row !== false) {
                    const column = HookData.column.dataKey
                    const row = HookData.cell.text
                    
                    for (let index = 0; index < PDF.fill_row_detail.length; index++) {
                      const element = PDF.fill_row_detail[index];
                      if (column == element.name_row) {
                        for (let index2 = 0; index2 < element.detail_row.length; index2++) {
                         const element_fill = element.detail_row[index2];
                          if (element_fill.check_text == row) {
                            HookData.cell.styles.fillColor = element_fill.fill_color
                          }
                        }
                      }
                    }
                    
                  }
                  

                  },
                  didDrawPage: () => {
                  doc.setFontSize(13);
                  doc.text(text_datePDF,datePDF_pos[0],datePDF_pos[1],null,null,"right")
                  }          
              });

              const pageCount = doc.internal.getNumberOfPages()
              const PageTo_pos = [PDF.setPosition[2],PDF.setPosition[3]]
              for (let index = 0; index < pageCount; index++) {
                doc.setPage(index)
                doc.setFontSize(13);
                let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber
                const text_PageTo = `หน้า ${pageCurrent} จาก ${pageCount}`
                doc.text(text_PageTo,PageTo_pos[0],PageTo_pos[1], null, null, "right")
                
                if (PDF.textHeader_allPages) {
                  const pageWidth = doc.internal.pageSize.getWidth();
                  doc.setFontSize(18);
                  const textWidth = doc.getStringUnitWidth(PDF.setTextHeader_allPages) * doc.internal.getFontSize();
                  const x = (pageWidth - textWidth) / 2;
                  doc.text(PDF.setTextHeader_allPages, x, 60);
                } 
              }

              const setPaper = PDF.streak === 'l' ? '(แนวนอน)' : '(แนวตั้ง)'
              doc.save(`${PDF.FileName} ${setPaper} ${time}.pdf`);
        },
    },
}

export default editor_PDF


// import { jsPDF } from "jspdf";
// import {font} from '../../public/assets/font/Sarabun-Regular-normal';

// const editor_PDF = {
//     data() {
//         return {
//             th: this.$thaidate,
//         }
//     },
//     methods: {
//         printPDF(head_PDF,data_PDf,data,PDF){

//             const dateObj = new Date();
//             let time = `${dateObj.getDate()}-${dateObj.getMonth()+1}-${dateObj.getFullYear()+543}`

//             const text_datePDF = `ข้อมูล ณ วันที่ ${this.changeDateToThai(dateObj)}`
//             const datePDF_pos = [PDF.setPosition[0],PDF.setPosition[1]]

//               const doc = new jsPDF(PDF.streak, 'pt');
//               doc.addFileToVFS("m.ttf", font);
//                   doc.addFont("m.ttf","m","normal");
//                   doc.setFont("m");  
              
//               doc.autoTable({
//                 head:[head_PDF],
//                 startY: PDF.startMargin,
//                 margin: PDF.marginPDF,
//                 styles: {

//                           font:'m',
                                              
//                         },
//                         headStyles:{
//                             fontSize: PDF.Col_FontSize,
//                             fontStyle: 'bolder',
//                             minCellWidth: PDF.minCell,
//                             halign: 'center',
//                             valign: 'middle',
//                             fillColor:PDF.fillColorPDF,
//                           },
//                           bodyStyles:{
//                             fontSize: PDF.Body_FontSize,
                            
//                           },
//                           columnStyles: PDF.columnsStyles,       
//                 columns: data_PDf, 
//                 body : data,
//                 theme: PDF.PDF_Styles,

//                   didParseCell:  (HookData) =>{
//                     if (HookData.cell.text[0]== '' || HookData.cell.text[0]== null ||  
//                     HookData.cell.text[0]== 'null' || HookData.cell.text[0]== undefined
//                     || HookData.cell.text[0]== ' -' ) {
                      
//                         HookData.cell.text = '-';
//                     }     
//                     if (HookData.cell.text[0]== '-' ) {
//                       // console.log(HookData)
//                       HookData.cell.styles.halign = 'center';
//                       HookData.cell.styles.valign = 'middle';
//                   }

                  
//                   if (PDF.checkBody_Center) {
//                     const column = HookData.column.dataKey
//                     PDF.Body_Center.filter((item)=>{
//                         if (column === item) {
//                             HookData.cell.styles.halign = 'center';
//                         }
//                     })
//                   }
//                    //add body data to summarize value
//                    if (PDF.checkBody_rowSpan) {
//                     for (let index = 0; index < PDF.Body_rowSpan.length; index++) {
//                       const element = PDF.Body_rowSpan[index];
//                       // console.log(element)
//                       if (HookData.column.dataKey === element.dataKey) {
//                         if (HookData.cell.raw === element.raw) {
//                           HookData.cell[element.P_all] = element.num
                      
//                           HookData.cell.styles.halign = element.halign ;
//                           HookData.cell.styles.valign = element.valign;
//                         }
//                       }
//                     }
//                   }
//                   //********************************** */

//                   if (PDF.check_fill_row !== undefined && PDF.check_fill_row !== false) {
//                     const column = HookData.column.dataKey
//                     const row = HookData.cell.text
                    
//                     for (let index = 0; index < PDF.fill_row_detail.length; index++) {
//                       const element = PDF.fill_row_detail[index];
//                       if (column == element.name_row) {
//                         for (let index2 = 0; index2 < element.detail_row.length; index2++) {
//                          const element_fill = element.detail_row[index2];
//                           if (element_fill.check_text == row) {
//                             HookData.cell.styles.fillColor = element_fill.fill_color
//                           }
//                         }
//                       }
//                     }
                    
//                   }

//                   },
//                   didDrawPage: () => {
//                   doc.setFontSize(13);
//                   doc.text(text_datePDF,datePDF_pos[0],datePDF_pos[1],null,null,"right")
//                   }          
//               });

//               const pageCount = doc.internal.getNumberOfPages()
//               const PageTo_pos = [PDF.setPosition[2],PDF.setPosition[3]]
//               for (let index = 0; index < pageCount; index++) {
//                 doc.setPage(index)
//                 doc.setFontSize(13);
//                 let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber
//                 const text_PageTo = `หน้า ${pageCurrent} จาก ${pageCount}`
//                 doc.text(text_PageTo,PageTo_pos[0],PageTo_pos[1], null, null, "right")
                
//                 if (PDF.textHeader_allPages) {
//                   const pageWidth = doc.internal.pageSize.getWidth();
//                   doc.setFontSize(18);
//                   const textWidth = doc.getStringUnitWidth(PDF.setTextHeader_allPages) * doc.internal.getFontSize();
//                   const x = (pageWidth - textWidth) / 2;
//                   doc.text(PDF.setTextHeader_allPages, x, 60);
//                 } 
//               }

//               const setPaper = PDF.streak === 'l' ? '(แนวนอน)' : '(แนวตั้ง)'
//               doc.save(`${PDF.FileName} ${setPaper} ${time}.pdf`);
//         },
//     },
// }

// export default editor_PDF
